// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/31330.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contenidor global del Parallax */
.parallax-container {
    position: relative; /* Necessari per mantenir el contingut a sobre */
    min-height: 100vh;
    overflow: hidden;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
    background-size: cover;
  }
  
  /* Parallax efecte */
  .parallax-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: inherit; /*linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url('../images/31330.jpg');*/
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    transform: translateZ(-1px) scale(2);
    /*opacity: 0.3;*/
  }

  .parallax-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8); /* Controla la transparència aquí */
    z-index: 1;
  }
  
  
  /* Contingut principal */
  .content {
    position: relative;
    z-index: 1;
    padding: 2rem;
   /* margin-top: 60px; /* Ajusta segons l'alçada de la barra de navegació */
  }
  
  /* Estil del Hero Section */
  .hero {
    text-align: center;
    padding: 2rem;
    color: #333;
  }
  
  .hero-title {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }
  
  .hero-subtitle {
    font-size: 1.25rem;
    color: #666;
  }
  
  /* Estil per a la secció About */
  .about {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2rem;
  }
  
  .about-content {
    max-width: 50%;
  }
  
  .about-image {
    max-width: 40%;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  /* Secció de "Call to Action" */
  .call-to-action {
    text-align: center;
    padding: 2rem;
  }
  
  .call-to-action h2 {
    margin-bottom: 1rem;
  }
  
  .call-to-action .btn {
    padding: 0.5rem 1.5rem;
    font-size: 1.25rem;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/home.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,kBAAkB,EAAE,gDAAgD;IACpE,iBAAiB;IACjB,gBAAgB;IAChB,iFAAoE;IACpE,sBAAsB;EACxB;;EAEA,oBAAoB;EACpB;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB,EAAE,mGAAmG;IACxH,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,oCAAoC;IACpC,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,mCAAmC;IACzE,UAAU;EACZ;;;EAGA,wBAAwB;EACxB;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;GACd,yEAAyE;EAC1E;;EAEA,2BAA2B;EAC3B;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA,gCAAgC;EAChC;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA,+BAA+B;EAC/B;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB","sourcesContent":["/* Contenidor global del Parallax */\r\n.parallax-container {\r\n    position: relative; /* Necessari per mantenir el contingut a sobre */\r\n    min-height: 100vh;\r\n    overflow: hidden;\r\n    background: url('../images/31330.jpg') no-repeat center center fixed;\r\n    background-size: cover;\r\n  }\r\n  \r\n  /* Parallax efecte */\r\n  .parallax-container::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: -1;\r\n    background: inherit; /*linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url('../images/31330.jpg');*/\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-attachment: fixed;\r\n    transform: translateZ(-1px) scale(2);\r\n    /*opacity: 0.3;*/\r\n  }\r\n\r\n  .parallax-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(255, 255, 255, 0.8); /* Controla la transparència aquí */\r\n    z-index: 1;\r\n  }\r\n  \r\n  \r\n  /* Contingut principal */\r\n  .content {\r\n    position: relative;\r\n    z-index: 1;\r\n    padding: 2rem;\r\n   /* margin-top: 60px; /* Ajusta segons l'alçada de la barra de navegació */\r\n  }\r\n  \r\n  /* Estil del Hero Section */\r\n  .hero {\r\n    text-align: center;\r\n    padding: 2rem;\r\n    color: #333;\r\n  }\r\n  \r\n  .hero-title {\r\n    font-size: 2.5rem;\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .hero-subtitle {\r\n    font-size: 1.25rem;\r\n    color: #666;\r\n  }\r\n  \r\n  /* Estil per a la secció About */\r\n  .about {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 2rem;\r\n  }\r\n  \r\n  .about-content {\r\n    max-width: 50%;\r\n  }\r\n  \r\n  .about-image {\r\n    max-width: 40%;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  /* Secció de \"Call to Action\" */\r\n  .call-to-action {\r\n    text-align: center;\r\n    padding: 2rem;\r\n  }\r\n  \r\n  .call-to-action h2 {\r\n    margin-bottom: 1rem;\r\n  }\r\n  \r\n  .call-to-action .btn {\r\n    padding: 0.5rem 1.5rem;\r\n    font-size: 1.25rem;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
